(function () {
    'use strict';

    angular
        .module('travelExpenses')
        .controller('ChooseExpenseController', ChooseExpenseController);

        ChooseExpenseController.$inject = ['$uibModalInstance', 'toastr', 'CitiesByExpoService', 'TravelExpenseService', 'ExpoService', 'SellerService', 'EventsService', 'statement', 'expenseTypeList', 'paymentTypeList', 'travelExpensesStatementList'];

    function ChooseExpenseController($uibModalInstance, toastr, CitiesByExpoService, TravelExpenseService, ExpoService, SellerService, EventsService, statement, expenseTypeList, paymentTypeList, travelExpensesStatementList) {

        var vm = this;

        /* Variables */
        vm.statement              = statement;
        vm.flag                   = false;
        vm.queryResults           = true;
        vm.datePicker             = {"autoApply": true};
        vm.expenseTypeSelected    = {};
        vm.expenseTypeList        = expenseTypeList;
        vm.paymentTypeSelected    = {};
        vm.paymentTypeList        = paymentTypeList;
        vm.dateOptions            = {
            locale: {
                format: 'MM/DD/YYYY',
                cancelLabel: 'Close'
            }
        };
        vm.selectOptionAll = [{
            name: '--- All ---',
            id: -1
        }];
        vm.description            = '';
        vm.expenseDate            = {};
        vm.expoSelected           = {};
        vm.citySelected           = {};
        vm.othersEventsSelected   = {};
        vm.othersEventsList       = [];
        vm.cities                 = [];
        vm.expos                  = [];
        vm.query                  = [];
        vm.expenses               = [];
        vm.sellers                = [];
        vm.sellerSelected         = '';
        vm.isApprovedSelected     = -1;
        vm.isApproved             = [
                                        {id : -1, name : '-- All --'},
                                        {id : 1, name : 'Yes'},
                                        {id : 0, name : 'No'}
                                    ];
        

        /* Pagination */
        vm.pageChanged            = pageChanged;
        vm.setPage                = setPage;
        vm.totalItems             = [];
        vm.to                     = [];
        vm.currentPage            = null;
        vm.itemsPerPage           = [];
        vm.page                   = 1;
        
        /* Modal Methods */
        vm.ok               = ok;
        vm.cancel           = cancel;

        /* Other Methods */
        vm.getByFilter            = getByFilter;
        vm.chooseExpense          = chooseExpense;
        vm.convertToUTC           = convertToUTC;
        vm.getOthersEvents        = getOthersEvents;
        vm.selectExpo             = selectExpo;
        vm.loadSellers            = loadSellers;
        vm.selectCitiesByExpo     = selectCitiesByExpo;
        
        /* Modal */
        function ok () {
            $uibModalInstance.close();
        }

        function cancel () {
            $uibModalInstance.close();
        }

        /* Methods */

        function activate() {
            vm.loadSellers();
            vm.getByFilter();
            vm.selectExpo();
        }

        function convertToUTC(date)
        {
            return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
        }

        function getOthersEvents() {
            EventsService.getOthersEvents().then(function(response){
                vm.othersEventsList = response.data;
            });
        }

        function loadSellers() {
            SellerService.getStaff().then(function(response) {
                vm.sellers = vm.selectOptionAll.concat(response.data);
            }).catch(function(err) {
            });
        }

        function selectExpo () {
            ExpoService.getExpos().then(function(response){
                vm.expos = response.data;
            }).catch(function(err) {
            });
        }

        function selectCitiesByExpo () {
            vm.citySelected = {};
            CitiesByExpoService.getCities(vm.expoSelected.id).then(function(response){
                vm.cities = response.data;
                vm.cities.unshift({location_id : -1, city_name: '-- All --'});
                vm.citySelected = {location_id : -1, city_name: '-- All --'};
                if (vm.expense) {
                    vm.citySelected = $filter('filter')(vm.cities, {expos_locations_id: vm.expense.expo_location_id})[0];
                }
            }).catch(function(err) {
            });
        }

        function getByFilter() {
            vm.flag = false;
            vm.queryResults = true;
            let query = {};
            if (typeof vm.expenseDate.startDate !== 'undefined' && typeof vm.expenseDate.endDate !== 'undefined') {
                query['start_date'] = vm.convertToUTC(new Date(vm.expenseDate.startDate));
                query['end_date'] = vm.convertToUTC(new Date(vm.expenseDate.endDate));
            }
            if (typeof vm.expoSelected !== 'undefined' && vm.expenseTypeSelected.id == 'physical_event') {
                query['expo_id'] = vm.expoSelected.id;
            }
            if (typeof vm.citySelected !== 'undefined' && vm.expenseTypeSelected.id == 'physical_event' && vm.citySelected.location_id > -1) {
                query['location_id'] = vm.citySelected.location_id;
            }
            if (typeof vm.othersEventsSelected !== 'undefined' && vm.othersEventsSelected.id !== 'other_event') {
                query['other_event_id'] = vm.othersEventsSelected.id;
            }
            if (typeof vm.filePath !== 'undefined' && vm.filePath !== '') {
                query['file_path'] = vm.filePath;
            }
            if (typeof vm.picture !== 'undefined' && vm.picture !== '') {
                query['file_path'] = vm.picture;
            }
            if (typeof vm.selectedCurrency !== 'undefined' && vm.selectedCurrency !== '') {
                query['currency'] = vm.selectedCurrency.code;
            }
            if (typeof vm.value !== 'undefined' && vm.value !== '') {
                query['value'] = vm.value;
            }
            if (typeof vm.description !== 'undefined') {
                query['description'] = vm.description;
            }
            if (typeof vm.expenseTypeSelected !== 'undefined'  && vm.expenseTypeSelected.id !== 'all') {
                query['type'] = vm.expenseTypeSelected.id;
            }
            if (typeof vm.paymentTypeSelected !== 'undefined'  && vm.paymentTypeSelected.id !== 'all') {
                query['payment_type'] = vm.paymentTypeSelected.id;
            }
            if (typeof vm.sellerSelected !== 'undefined') {
                query['seller_id'] = vm.sellerSelected.id;
            }
            query['from'] = 'travel_expense_assoc';
            query['is_approved'] = vm.isApprovedSelected;
            query['page'] = vm.page;

            TravelExpenseService.getExpense(query).then(function(response){
                vm.flag = true;
                vm.queryResults = true;
                if(response.data.data.length == 0) {
                    vm.queryResults = false;
                }
                vm.expenses = response.data.data;
                vm.totalItems = response.data.total;
                vm.to = response.data.to;
                vm.setPage(response.data.current_page);
                vm.itemsPerPage = response.data.per_page;
            }).catch(function(err) {
            });
        }

        function setPage (pageNo) {
            vm.currentPage = pageNo;
        }

        function pageChanged (pageNo) {
            vm.page = vm.currentPage;
            vm.getByFilter();
        }

        function chooseExpense(expense) {
            let query = {};
            query['expense_id'] = expense.id;
            query['statement_id'] = vm.statement.id;
            TravelExpenseService.updateStatement(query).then(function(response){
                vm.statement.fin_travel_expense_id = expense.id;
                toastr.success('This Expense has been successfully updated');
                travelExpensesStatementList.getByFilter();
                vm.cancel();
            }).catch(function(err) {
            });
        }

        activate();
    }

})();